/**
 * Lighting Toggle Feature
 * Toggles between regular and lit product images on collection pages
 */

class LightingToggle {
  constructor() {
    this.toggle = document.getElementById('lighting-toggle');
    if (!this.toggle) return;
    
    this.isActive = false;
    this.storageKey = 'lighting-toggle-state';
    
    this.init();
  }
  
  init() {
    // Restore saved state from localStorage
    const savedState = localStorage.getItem(this.storageKey);
    if (savedState === 'true') {
      this.toggle.checked = true;
      this.isActive = true;
      this.applyLightingState();
    }
    
    // Listen for toggle changes
    this.toggle.addEventListener('change', (e) => {
      this.isActive = e.target.checked;
      this.applyLightingState();
      localStorage.setItem(this.storageKey, this.isActive);
    });
    
    // Listen for AJAX page updates (filters, pagination, etc.)
    this.observeContentChanges();
  }
  
  applyLightingState() {
    if (this.isActive) {
      document.body.classList.add('lighting-active');
    } else {
      document.body.classList.remove('lighting-active');
    }
    
    // Dispatch custom event for other scripts to react to
    const event = new CustomEvent('lightingToggle', {
      detail: { active: this.isActive }
    });
    document.dispatchEvent(event);
  }
  
  observeContentChanges() {
    // Watch for grid updates (pagination, filtering, etc.)
    const gridContainer = document.querySelector('[data-render-grid]');
    if (!gridContainer) return;
    
    const observer = new MutationObserver((mutations) => {
      // Reapply state after content updates
      if (this.isActive) {
        document.body.classList.add('lighting-active');
      }
    });
    
    observer.observe(gridContainer, {
      childList: true,
      subtree: true
    });
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new LightingToggle();
  });
} else {
  new LightingToggle();
}

// Re-initialize after AJAX updates (for themes with dynamic content loading)
document.addEventListener('shopify:section:load', () => {
  new LightingToggle();
});

